import React, { useState, useEffect } from "react";
import { useParams,Link } from 'react-router-dom';
import axios from 'axios';

import { useRecoilState } from "recoil";
import { AdminMenus } from "../../../components/recoil/atoms/Menus";

import Header from "../../components/includes/Header";
import {addThousandPoint} from "../../../components/common/Common";

/* css */
import "../../../css/admin_layout.css";
import "../../../css/admin.css";

//매출세부정보
export const SalesDetail = () => {
  let { bh_idx,months } = useParams();
 
  const [varAdminMenus,setAdminMenus] = useRecoilState(AdminMenus);

  const [varMSaleClassList,setMSaleClassList] = useState([]);
  const [varFSaleClassList,setFSaleClassList] = useState([]);

  //전체매출관련
  const [varBranchInfo,setBranchInfo] = useState({});


  //센터 정보 호출
  const GetSalesInformation = async() => {
    const marray = months.split('-');
    const smonth = marray[0]+'년 '+Number(marray[1]).toString()+'월';

    const sendData = {bh_idx:bh_idx,months:months};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/_get_sales_information`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
      if(datas.retvalue === 1) {
        //전체
        const branchData = {name:"",months:smonth,tstudent:0,troyalty:0};
        let total_student = 0;
        let total_royalty = 0;

        const showData = {classname:"",student:0,royalty:0,list:[]};
        const classData = {num:0,classroom:"",royalty:0,parent:"",children:"",studys:""};

        //마마몽떼--------
        const dataInfo1 = datas.mamamontes;
        if(dataInfo1.length > 0) {
          branchData.name = dataInfo1[0].bh_company;

          let idx1 = 0;
          let iarr1 = -1;
          let lineData1 = {};
          let lineArray1 = [];
          let totalArray1 = [];
          let tstudent1 = 0;
          let troyalty1 = 0;

          for(var i1=0;  i1< dataInfo1.length; i1++) {
            const lData = dataInfo1[i1];
            //클래스명이 다르면
            if(idx1 !== lData.ph_cl_idx) {
              if(i1 > 0) {
                lineData1.student = tstudent1;
                lineData1.royalty = troyalty1;
                lineData1.list = lineArray1;
                totalArray1.push(lineData1);
                iarr1 = -1;
                tstudent1 = 0;
                troyalty1 = 0;
              }
              idx1 = lData.ph_cl_idx;  //클래스번호
              lineData1 = {...showData}; //객체복사
              lineData1.classname = lData.cl_name; //클래스면 저장
              lineArray1 = [];
            }
            iarr1++;
            tstudent1++;
            total_student++;
            troyalty1 += lData.ph_price;
            total_royalty += lData.ph_price;

            //클래스별 내역정보 ---> 객체 배열로 저장
            let addLine = {...classData};
            addLine.num = iarr1+1;
            addLine.classroom = lData.cl_name;
            addLine.royalty = addThousandPoint(lData.ph_price);
            addLine.parent = lData.mem_name;
            addLine.children = lData.ch_name;
            addLine.studys = lData.tcnt+'/'+lData.cl_studys;
            lineArray1.push(addLine);

            if(i1 === dataInfo1.length-1) {
              lineData1.student = tstudent1;
              lineData1.royalty = troyalty1;
              lineData1.list = lineArray1;
              totalArray1.push(lineData1);
            }
          }
          
          //총매출정보
          setBranchInfo(branchData);  //총괄 정보
          setMSaleClassList(totalArray1); //클래스별 로열티 내역
          console.log(branchData);
          console.log(totalArray1);
        }

        //플라이
        const dataInfo2 = datas.flys;
        if(dataInfo2.length > 0) {
          if(branchData.name === "") branchData.name = dataInfo2[0].bh_company;

          let idx2 = 0;
          let iarr2 = -1;
          let lineData2 = {};
          let lineArray2 = [];
          let totalArray2 = [];
          let tstudent2 = 0;
          let troyalty2 = 0;

          for(var i2=0;  i2< dataInfo2.length; i2++) {
            const lData = dataInfo2[i2];
            //클래스명이 다르면
            if(idx2 !== lData.ph_cl_idx) {
              if(i2 > 0) {
                lineData2.student = tstudent2;
                lineData2.royalty = troyalty2;
                lineData2.list = lineArray2;
                totalArray2.push(lineData2);
                iarr2 = -1;
                tstudent2 = 0;
                troyalty2 = 0;
              }
              idx2 = lData.ph_cl_idx;  //클래스번호
              lineData2 = {...showData}; //객체복사
              lineData2.classname = lData.cl_name; //클래스면 저장
              lineArray2 = [];
            }
            iarr2++;
            tstudent2++;
            total_student++;
            troyalty2 += lData.ph_price;
            total_royalty += lData.ph_price;
            //클래스별 내역정보 ---> 객체 배열로 저장
            let addLine = {...classData};
            addLine.num = iarr2+1;
            addLine.classroom = lData.cl_name;
            addLine.royalty = addThousandPoint(lData.ph_price);
            addLine.parent = lData.mem_name;
            addLine.children = lData.ch_name;
            addLine.studys = lData.tcnt+'/'+lData.tstudys;
            lineArray2.push(addLine);

            if(i2 === dataInfo2.length-1) {
              lineData2.student = tstudent2;
              lineData2.royalty = troyalty2;
              lineData2.list = lineArray2;
              totalArray2.push(lineData2);
            }
          }

          setFSaleClassList(totalArray2); //클래스별 로열티 내역
          console.log(totalArray2);
        }
        //총매출정보
        branchData.tstudent = total_student;
        branchData.troyalty = total_royalty;
        console.log(branchData);
        setBranchInfo(branchData);  //총괄 정보
      }
    });
  }

  //페이지 정보 표시 - 최초
  useEffect(() => {
    setAdminMenus({type:'SALES',item:'SalesReport'});
    console.log(varAdminMenus);
    if(Number(bh_idx) > 0)  GetSalesInformation();     
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  return varMSaleClassList.length === 0 && varFSaleClassList.length === 0?null:(
    <div id="admin_contents" className="adm_contents">
      <Header varTitle={'매출 리포트 상세'} varDirection={'매출 리포트 상세'}/>
        <div className="admin-content">
          <div style={{display:"flex",justifyContent:"space-between"}}>
            <div>{`센터 : ${varBranchInfo.name}`}</div>
            <div>{`매출 월 : ${varBranchInfo.months}`}</div>
            <div>{`총 청구인원 : ${varBranchInfo.tstudent}명`}</div>
            <div>{`총월별 로열티 : ${addThousandPoint(varBranchInfo.troyalty)}원`}</div>
          </div>
          {varMSaleClassList.map((classes,i) => (
            <div key={'mclasses_'+i} className="main-box" style={{marginTop:"30px"}}>
              <div style={{display:"flex",justifyContent:"space-between",padding:"20px 10px"}}>
                <div>{classes.classname}</div>
                <div>{`청구인원 : ${classes.student}명`}</div>
                <div>{`로열티 : ${addThousandPoint(classes.royalty)}원`}</div>
              </div>
              <table className="write">
                <colgroup>
                  <col width="10%"></col><col width="30%"></col>
                  <col width="15%"></col><col width="15%"></col><col width="15%"></col><col width="15%"></col>
                </colgroup>
                <thead>
                  <tr>
                    <th style={{paddingLeft:"0px",textAlign:"center"}}>인원</th>
                    <th style={{paddingLeft:"0px",textAlign:"left"}}>클래스</th>
                    <th style={{paddingLeft:"0px",textAlign:"center"}}>신규로열티</th>
                    <th style={{paddingLeft:"0px",textAlign:"center"}}>학부모</th>
                    <th style={{paddingLeft:"0px",textAlign:"center"}}>원생</th>
                    <th style={{paddingLeft:"0px",textAlign:"center"}}>수업차수</th>
                  </tr>
                </thead>
                <tbody>
                  {classes.list.map((lines,j) => (
                    <tr key={'lines_'+j}>
                      <td style={{textAlign:"center"}}>{lines.num}</td>
                      <td style={{paddingLeft:"0px",textAlign:"left"}}>{lines.classroom}</td>
                      <td style={{textAlign:"center"}}>{lines.royalty}</td>
                      <td style={{textAlign:"center"}}>{lines.parent}</td>
                      <td style={{textAlign:"center"}}>{lines.children}</td>
                      <td style={{textAlign:"center"}}>{lines.studys}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ))}
          {varFSaleClassList.map((classes,i) => (
            <div key={'fclasses_'+i} className="main-box" style={{marginTop:"30px"}}>
              <div style={{display:"flex",justifyContent:"space-between",padding:"20px 10px"}}>
                <div>{classes.classname}</div>
                <div>{`청구인원 : ${classes.student}명`}</div>
                <div>{`로열티 : ${addThousandPoint(classes.royalty)}원`}</div>
              </div>
              <table className="write">
                <colgroup><col width="10%">
                  </col><col width="30%"></col>
                  <col width="15%"></col><col width="15%"></col><col width="15%"></col><col width="15%"></col>
                </colgroup>
                <thead>
                  <tr>
                    <th style={{paddingLeft:"0px",textAlign:"center"}}>인원</th>
                    <th style={{paddingLeft:"0px",textAlign:"left"}}>클래스</th>
                    <th style={{paddingLeft:"0px",textAlign:"center"}}>신규로열티</th>
                    <th style={{paddingLeft:"0px",textAlign:"center"}}>학부모</th>
                    <th style={{paddingLeft:"0px",textAlign:"center"}}>원생</th>
                    <th style={{paddingLeft:"0px",textAlign:"center"}}>수업차수</th>
                  </tr>
                </thead>
                <tbody>
                  {classes.list.map((lines,j) => (
                    <tr key={'lines_'+j}>
                      <td style={{textAlign:"center"}}>{lines.num}</td>
                      <td style={{paddingLeft:"0px",textAlign:"left"}}>{lines.classroom}</td>
                      <td style={{textAlign:"center"}}>{lines.royalty}</td>
                      <td style={{textAlign:"center"}}>{lines.parent}</td>
                      <td style={{textAlign:"center"}}>{lines.children}</td>
                      <td style={{textAlign:"center"}}>{lines.studys}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ))}
          <div style={{position:"relative",width:"100%",marginTop:"10px"}}>
            <Link to={'/Admin/SalesList'} className="btn line" style={{width:"100px",position:"absolute",left:"0px"}}>목록</Link>
          </div>
        </div>
    </div>
  );
}
export  default SalesDetail;